module.exports = __webpack_public_path__ + "static/branches-61f4e7968adbdc85994b1bcb56766166.svg";